import React,{useState} from 'react'
import "./Header.css"
import { BiMenuAltRight } from "react-icons/bi";
import OutsideClickHandler from "react-outside-click-handler";





function Header({ onValueClick,onstartedClick,onrecedencyClick,oncontactClick }) {
  const [menuOpened, setMenuOpened] = useState(false);
  const getMenuStyles = (menuOpened) => {
    if (document.documentElement.clientWidth <= 800) {
      return { right: !menuOpened && "-100%" };
    }
    
  };

  return (
    <section className="h-wrapper">
    <div className="h-container"  >
    <img src="./logo.jpg" alt="logo" height={120} />
   <h1>REAL ESTATE</h1>

   <OutsideClickHandler
          onOutsideClick={() => {
            setMenuOpened(false);
          }}
        >
    <div className="h-menu " style={getMenuStyles(menuOpened)} >

    <a   onClick={onrecedencyClick}>Recedencies</a>
        
        <a   onClick={onValueClick}>Our Value</a>
        
        <a  onClick={onstartedClick}>Get Started</a>
        <button onClick={oncontactClick} className='button'>Contact Us</button>
        

    </div>
    </OutsideClickHandler>

    <div className="menu-icon"  onClick={() => setMenuOpened((prev) => !prev)}
        >
    <BiMenuAltRight size={30}/>

    </div>
    </div>


    </section>
  )
}

export default Header
